import styled from 'styled-components';
import { Check } from 'lucide-react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger, Button } from 'components';

export const SectionCard = styled.div.attrs({
  className: 'rounded-md border border-border bg-card px-2 py-1',
})``;

export const SectionAccordion = styled(Accordion).attrs({
  className: 'w-full',
})``;

export const SectionItem = styled(AccordionItem).attrs({
  className: 'border-b-0',
})``;

export const SectionTrigger = styled(AccordionTrigger).attrs({
  variant: 'arrow',
  className: 'items-center py-1.5 hover:no-underline [&>svg:first-child]:translate-y-0',
})``;

export const SectionContent = styled(AccordionContent).attrs({
  className: 'pb-1',
})``;

export const TriggerRow = styled.span.attrs({
  className: 'flex flex-1 flex-wrap items-center gap-x-2 gap-y-2',
})``;

export const TriggerTitle = styled.span.attrs({
  className: 'text-xs font-medium',
})``;

export const CollapsedIcons = styled.span.attrs({
  className: 'flex flex-wrap items-center gap-1',
})``;

export const RowList = styled.ul.attrs({
  className: 'flex flex-col',
})``;

export const Row = styled.li.attrs({
  className: 'flex items-start gap-2 border-t border-border py-1.5',
})``;

export const RowMain = styled.div.attrs({
  className: 'flex min-w-0 flex-1 items-center gap-2',
})``;

export const RowBody = styled.div.attrs({
  className: 'flex min-w-0 flex-1 flex-col',
})``;

export const RowName = styled.span.attrs({
  className: 'text-xs font-semibold leading-4 text-foreground',
})``;

export const RowSubtitle = styled.span.attrs({
  className: 'text-xs font-semibold leading-4 text-muted-foreground',
})``;

export const RowActions = styled.div.attrs({
  className: 'flex shrink-0 flex-wrap items-start gap-1 pb-1',
})``;

export const RowActionButton = styled(Button).attrs({
  size: 'icon-xs',
  className: 'size-6 rounded-lg p-0',
})``;

export const RowActionCheckIcon = styled(Check).attrs({
  strokeWidth: 1.5,
  nonScalingStroke: true,
})``;
